import { RouteRecordRaw } from 'vue-router'


const routes: Array<RouteRecordRaw> = [
  { path: '/normal-tv-menu', name: 'normal-tv-menu', meta: { title: '横屏展示菜单' }, component: () => import('../views/trend-chart/TrendScreen.vue') },
  { path: '/normal-football-board', name: 'normal-football-board', meta: { title: '今日精彩比赛' }, component: () => import('../views/trend-chart/TrendScreen.vue') },
  { path: '/football-match-board', name: 'football-match-board', meta: { title: '竞彩足球赛程' }, component: () => import(/* webpackChunkName: "about" */ '../views/trend-chart/TrendScreen.vue') },
  {
    path: '/trend-chart',
    name: 'trend-chart',
    meta: {
      title: '大乐透趋势图表'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/trend-chart/TrendScreen.vue')
  },
  {
    path: '/ranking-game-trend-chart',
    name: 'ranking-game-trend-chart',
    meta: {
      title: '排列游戏趋势图'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/trend-chart/TrendScreen.vue')
  },
  {
    path: '/seven-start-game-trend-chart',
    name: 'seven-start-game-trend-chart',
    meta: {
      title: '七星彩游戏趋势图'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/trend-chart/TrendScreen.vue')
  },
  {
    path: '/menu-trend-chart',
    name: 'menu-trend-chart',
    meta: {
      title: '菜单游戏趋势图'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/trend-chart/TrendScreen.vue')
  },
  // {
  //   path: '/menu-trend-test',
  //   name: 'menu-trend-test',
  //   meta: {
  //     title: '菜单游戏趋势图测试'
  //   },
  //   component: () => import(/* webpackChunkName: "about" */ '../views/trend-chart/TrendMenuTest.vue')
  // },
  // 走势图页面父容器
  {
    path: '/trend-chart-container',
    name: 'trend-chart-container',
    meta: {
      title: '走势图'
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/trend-chart/TrendScreen.vue'),
  }
]


export default routes
